import { z } from "zod";
export const NOTIFICATION_CHANNELS = [
    "teams_webhook",
    "teams_graph",
    "teams_channel",
    "outlook",
];
export const NOTIFICATION_EVENTS = [
    "task.assigned",
    "task.completed",
    "agent.status_changed",
    "approval.required",
];
export const createNotificationConfigSchema = z.object({
    companyId: z.string().uuid(),
    channel: z.enum(NOTIFICATION_CHANNELS),
    label: z.string().min(1).max(200).optional(),
    webhookUrl: z.string().url().optional(),
    recipientEmail: z.string().email().optional(),
    chatId: z.string().min(1).optional(),
    events: z.array(z.enum(NOTIFICATION_EVENTS)).min(1),
    enabled: z.boolean().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const updateNotificationConfigSchema = z.object({
    label: z.string().min(1).max(200).nullish(),
    webhookUrl: z.string().url().nullish(),
    recipientEmail: z.string().email().nullish(),
    chatId: z.string().min(1).nullish(),
    events: z.array(z.enum(NOTIFICATION_EVENTS)).min(1).optional(),
    enabled: z.boolean().optional(),
    metadata: z.record(z.unknown()).nullish(),
});
//# sourceMappingURL=notification.js.map